import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDr5NPlmAHO0czMGYIt0M3pdKoXOZRcgCg",
  authDomain: "vidify-23bab.firebaseapp.com",
  databaseURL: "https://vidify-23bab-default-rtdb.firebaseio.com",
  projectId: "vidify-23bab",
  storageBucket: "vidify-23bab.firebasestorage.app",
  messagingSenderId: "456973244530",
  appId: "1:456973244530:web:1cb65e88c29ead14750aeb",
  measurementId: "G-M77L3TPDLK"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

